import appPath from '../../lib/appPath';
import React, {Component} from 'react';
import {isAdminPanelRole, isAdminToolRole} from '../../auth/roles';
import {HighlightOff} from '@mui/icons-material';
import {Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Tab, Tabs, TextField, Tooltip} from '@mui/material';
import {throttle} from 'lodash';
import {connect} from 'react-redux';

import {
  addBalance, addBlockNo, addSMSType, addSenderId, changeDefaultSenderId, changePassword, changeStatus, editDLT,
  getAllAgent, getBlockNumber, getTenantDetails, getTenantUsers, impersonateUser
} from '../../actions/adminPanel';
import Table from '../../components/Table';
import {getFromLocalStorage} from '../../lib/utils';
import {getOidcAccessToken} from '../../auth/tokenUtils';
import OnboardOrg from './onboardOrg';
import OnboardingList from './onboardingList';
import SeedConfig from './seedConfig';
import SearchTab from './SearchTab';
import AccountStatusTab from './AccountStatusTab';
import customerColumns from './customerColumns';
import CustomerDetails from './details';

class AdminPanel extends Component {
  constructor(){
    super();
    this.state = {
      filteredAgentList : [],
      agentList : [],
      showOnboarding: false,
      showOnboardingList: false,
      showSeedConfig: false,
      activeTab: 0, // 0 = Customers, 1 = Search
      showFullDetails : false,
      showWait : false,
      showBlockNumber: false,
      blockNumber: '',
      blockedList: [],
      searchTerm: ''
    }
    this.detailsData = null;
    this.agentReq = true;
    this.addBalanceReq = false;
    this.addSMSTypeReq = false;
    this.changeStatusReq = false;
    this.editDLTReq = false;
    this.addSenderIdReq = false;
    this.changeDefaultSenderIdReq = false;
    this.addBlockNo = false
    this.getBlockNo = false
    this.changePasswordReq = false
    this.getTenantDetailsReq = false
    this.impersonateReq = false
    this.throttleInput = throttle(this.throttleInput.bind(this),300);
  }
  componentDidMount(){
    this.props.getAllAgent();
  }
  componentWillReceiveProps(nextProps){
    if(this.agentReq && nextProps.agentList && nextProps.agentList.success){
      this.agentReq = false;
      // Server order is kept as-is. /api/v3/organizations orders the WHOLE
      // filtered set before paging — account_status rank, then newest, then id
      // — so re-sorting here by date would silently throw that away and
      // reinstate a date-only order across the concatenated pages.
      const agentList = nextProps.agentList.data.institutes
        .map(el =>({...el, id: el.instituteId}));
      this.setState({agentList:agentList, filteredAgentList: agentList});
      return;
    }
    if(this.getTenantDetailsReq && nextProps.tenantDetailsRes && nextProps.tenantDetailsRes.success){
      this.getTenantDetailsReq = false;
      // Merge over the list row: the details response carries no
      // contactName/onboarding, and its name/tenantName can come back as ''
      // (support-tenants endpoint), which briefly showed "(no business
      // name)" after the row had shown it. Only non-empty details values
      // replace what the row already had.
      const row = this.detailsData || {};
      const details = nextProps.tenantDetailsRes.data || {};
      const merged = {...row};
      Object.keys(details).forEach((k) => {
        const v = details[k];
        const empty = v === undefined || v === null || v === '';
        if (!empty || row[k] === undefined) merged[k] = v;
      });
      this.detailsData = merged;
      this.forceUpdate(); // Re-render to show updated balance
      return;
    }
    if(this.addBalanceReq && nextProps.addBalanceRes){
      this.addBalanceReq = false;
      if(nextProps.addBalanceRes.success){
        this.agentReq = true;
        this.props.getAllAgent();
        alert("Balance added Successfully");
        this.setState({showFullDetails : false,showWait:false});
      } else{
        alert("Something went wrong, Please try again");
        this.setState({showWait:false});
      }
      return;
    }
    if(this.addSMSTypeReq && nextProps.addSMSTypeRes){
      this.addSMSTypeReq = false;
      if(nextProps.addSMSTypeRes.success){
        this.agentReq = true;
        this.props.getAllAgent();
        alert("SMS Type added Successfully");
        this.setState({showFullDetails : false,showWait:false});
      } else{
        alert("Something went wrong, Please try again");
        this.setState({showWait:false});
      }
      return;
    }
    if(this.changeStatusReq && nextProps.changeStatusReq){
      this.changeStatusReq = false;
      if(nextProps.changeStatusReq.success){
        this.agentReq = true;
        this.props.getAllAgent();
        alert("Status Changed Successfully");
        this.setState({showFullDetails : false,showWait:false});
      } else{
        alert("Something went wrong, Please try again");
        this.setState({showWait:false});
      }
      return;
    }
    if(this.editDLTReq && nextProps.editDLTReq){
      this.editDLTReq = false;
      if(nextProps.editDLTReq.success){
        this.agentReq = true;
        this.props.getAllAgent();
        alert("DLT ID Updated Successfully");
        this.setState({showFullDetails : false,showWait:false});
      } else{
        alert("Something went wrong, Please try again");
        this.setState({showWait:false});
      }
      return;
    }
    if(this.addSenderIdReq && nextProps.addSenderIdReq){
      this.addSenderIdReq = false;
      if(nextProps.addSenderIdReq.success){
        this.agentReq = true;
        this.props.getAllAgent();
        alert("Header Added Successfully");
        this.setState({showFullDetails : false,showWait:false});
      } else{
        alert("Something went wrong, Please try again");
        this.setState({showWait:false});
      }
      return;
    }
    if(this.changeDefaultSenderIdReq && nextProps.changeDefaultSenderIdReq){
      this.changeDefaultSenderIdReq = false;
      if(nextProps.changeDefaultSenderIdReq.success){
        this.agentReq = true;
        this.props.getAllAgent();
        alert("Default Header Changed Successfully");
        this.setState({showFullDetails : false,showWait:false});
      } else{
        alert("Something went wrong, Please try again");
        this.setState({showWait:false});
      }
      return;
    }
    if(this.addBlockNo && nextProps.addBlockNoRes){
      this.addBlockNo = false;
      if(nextProps.addBlockNoRes.success){
        alert("Block Number Added Successfully");
        this.setState({showWait:false});
      } else{
        alert("Something went wrong, Please try again");
        this.setState({showWait:false});
      }
      return;
    }
    if(this.getBlockNo && nextProps.blockNumberRes){
      this.getBlockNo = false;
      if(nextProps.blockNumberRes.success){
        this.setState({showWait:false, showBlockNumber: true, blockedList: nextProps.blockNumberRes.data.list});
      } else{
        alert("Something went wrong, Please try again");
        this.setState({showWait:false});
      }
      return;
    }
    if(this.changePasswordReq && nextProps.changePasswordRes){
      this.changePasswordReq = false
      this.getTenantDetailsReq = false;
      if(nextProps.changePasswordRes.success){
        this.agentReq = true;
        this.props.getAllAgent();
        alert("Password changed for requested User");
        this.setState({showFullDetails : false,showWait:false});
      } else{
        alert("Something went wrong, Please try again");
        this.setState({showWait:false});
      }
      return;
    }
    // Handle impersonation response
    if(this.impersonateReq && nextProps.impersonateUserRes){
      this.impersonateReq = false;
      if(nextProps.impersonateUserRes.success && nextProps.impersonateUserRes.data){
        const {access_token, accessToken, target_user_id, targetUserId, target_org_id, targetOrgId} = nextProps.impersonateUserRes.data;
        const token = access_token || accessToken;
        const userId = target_user_id || targetUserId;
        const orgId = target_org_id || targetOrgId;
        // Store impersonation info and reload to switch session
        const {targetUserName, targetOrgName} = this._pendingImpersonation || {};
        sessionStorage.setItem('combird_impersonation', JSON.stringify({
          accessToken: token,
          targetUserId: userId,
          targetOrgId: orgId,
          targetUserName: targetUserName || userId,
          targetOrgName: targetOrgName || orgId,
          actorToken: sessionStorage.getItem('combird_actor_token'),
        }));
        // Reload so all API calls use the impersonated token
        window.location.href = appPath('/dashboard');
      } else{
        alert("Impersonation failed: " + (nextProps.impersonateUserRes.error || 'Unknown error'));
        this.setState({showWait:false});
      }
      return;
    }
  }
  getStatusColor = (data) =>{
    let color = "red";
    if(data && data.status=="testing") color = "red";
    else if(data && data.status=="live") color = "green";
    else color = "yellow";
    return color;
  }
  openDetails = (data) => {
    // Show dialog immediately with existing data
    this.detailsData = data;
    this.setState({showFullDetails : true});
    // Fetch tenant details with balance - will update detailsData when response arrives
    this.getTenantDetailsReq = true;
    this.props.getTenantDetails(data.instituteId);
  }
  closeDetails = () =>{
    this.detailsData = null;
    this.setState({showFullDetails : false});
  }
  // A rename from the org dialog: patch the open details and the list rows
  // in place so the title and the Customer/Org column agree without a
  // round-trip or losing the operator's place in the list.
  handleOrgRenamed = (orgId, name) => {
    if (this.detailsData && (this.detailsData.instituteId === orgId || this.detailsData.id === orgId)) {
      this.detailsData = {...this.detailsData, name, tenantName: name, info: name};
    }
    const patch = (rows) => (rows || []).map(r =>
      (r.instituteId === orgId || r.id === orgId) ? {...r, name, tenantName: name, info: name} : r);
    this.setState({
      agentList: patch(this.state.agentList),
      filteredAgentList: patch(this.state.filteredAgentList),
    });
  }
  closeDetailsAndRefresh = () => {
    this.detailsData = null;
    this.agentReq = true;
    this.setState({showFullDetails : false});
    this.props.getAllAgent();
  }
  handleImpersonateUser = (targetUserId, targetOrgId, targetUserName, targetOrgName) => {
    if (!window.confirm(`Login as ${targetUserName || targetUserId}? This will create an impersonated session token.`)) return;
    this.impersonateReq = true;
    // The impersonated token carries no org_name claim, so the banner and
    // header can only show what we pass here. Fall back to the open org's
    // row so it is the business name, never the bare org id.
    const orgName = targetOrgName || this.detailsData?.name || this.detailsData?.tenantName || '';
    this._pendingImpersonation = { targetUserName, targetOrgName: orgName };
    this.setState({showWait:true});
    // Save current token as actor token for potential restore later
    sessionStorage.setItem('combird_actor_token', getOidcAccessToken());
    this.props.impersonateUser(targetUserId, targetOrgId);
  }
  addBalance = (params)=>{
    // Prevent admin_agent role from modifying balance (support_agent is allowed)
    const userRole = getFromLocalStorage().role;
    if (userRole === 'admin_agent') {
      alert("You don't have permission to modify balance");
      return;
    }

    this.addBalanceReq = true;
    this.setState({showWait:true});
    this.props.addBalance(this.detailsData.instituteId,params);
  }
  changePassword = (params) => {
    this.changePasswordReq  = true;
    this.setState({showWait:true});
    this.props.changePassword(params);
  }
  addSMSType = params =>{
    this.addSMSTypeReq = true;
    this.setState({showWait:true});
    this.props.addSMSType(this.detailsData.instituteId,params);
  }
  changeStatus = params =>{
    this.changeStatusReq = true;
    this.setState({showWait:true});
    this.props.changeStatus(this.detailsData.instituteId,params);
  }
  editDLT = params => {
    this.editDLTReq = true;
    this.setState({showWait:true});
    this.props.editDLT(this.detailsData.instituteId,params);
  }
  addSenderId = params =>{
    this.addSenderIdReq = true;
    this.setState({showWait:true});
    this.props.addSenderId(this.detailsData.instituteId,params);
  }
  changeDefaultSenderId = params =>{
    this.changeDefaultSenderIdReq = true;
    this.setState({showWait:true});
    this.props.changeDefaultSenderId(this.detailsData.instituteId,params);
  }
  addBlockNumber = () => {
    const {blockNumber} = this.state;
    const blockNumberList = blockNumber.replace(/ /g,'').split(',')
    if(blockNumber && blockNumberList.length > 0){
      this.addBlockNo = true;
      this.props.addBlockNo({"blockedNumberList" : blockNumberList})
      this.setState({showWait: true, blockNumber: ''})
    } else {
      alert("Please provide number")
    }
  }
  shoBlockedList = () => {
    this.getBlockNo = true
    this.props.getBlockNumber();
    this.setState({showWait: true})
  }
  closeBlockedList = () => {
    this.setState({showBlockNumber: false})
  }
  getTotalSMSCount = () => {
    const {agentList} = this.state
    // Sum balanceCredits across every loaded row (enriched ListOrganizationsV2
    // rows — numbers, coerced in the adminPanel action adapter). Legacy rows
    // without balanceCredits fall back to the old smsCount shape.
    // Testing accounts are excluded from the headline total (2026-09-06).
    // Their routes are pinned to the test SMPP operator, so their credits are
    // demo balances, not sellable inventory — and the legacy admin panel only
    // ever counted live tenants, which is the figure ops compare against.
    // They are still summed separately below so nothing is hidden.
    const totals = {}
    const testing = {}
    const addTo = (bucket) => (key, val) => {
      if (typeof val === 'number' && !isNaN(val)) bucket[key] = (bucket[key] || 0) + val
    }
    agentList.forEach(row => {
      const isTesting = String(row.accountStatus || '').toLowerCase() === 'testing'
      const add = addTo(isTesting ? testing : totals)
      const credits = row.balanceCredits
      if (credits && typeof credits === 'object' && Object.keys(credits).length > 0) {
        Object.keys(credits).forEach(k => add(k, credits[k]))
      } else if (row.smsCount) {
        add('promotional', row.smsCount.PROMO)
        add('transactional', row.smsCount.TRANS)
        add('otp', row.smsCount.OTP)
      }
    })
    // Same labels/order as the per-row Balance cell; unknown wallet types trail.
    const labels = {promotional: 'Promotional', transactional: 'Transactional', otp: 'OTP', general: 'General'}
    const order = ['otp', 'transactional', 'promotional', 'general']
    const keysOf = (bucket) => order.filter(k => bucket[k] !== undefined)
      .concat(Object.keys(bucket).filter(k => !order.includes(k)))
    const keys = keysOf(totals)
    const testingKeys = keysOf(testing)
    return (
      <div style={{marginTop: -12}}>
        {keys.length === 0 ?
          <p style={{display: 'inline-block', fontSize: 16, color: 'rgba(0, 0, 0, 0.5)'}}>No balances loaded</p>
          :
          keys.map(k => (
            <p key={'total-balance-' + k} style={{display: 'inline-block', fontSize: 16, marginRight: 10}}>
              <span style={{color: 'rgba(0, 0, 0, 0.5)'}}>{labels[k] || k}:</span> {totals[k].toLocaleString()}
            </p>
          ))
        }
        {testingKeys.length > 0 &&
          <p style={{fontSize: 12, color: 'rgba(0, 0, 0, 0.5)', marginTop: -8}}>
            Excluded — testing accounts:{' '}
            {testingKeys.map(k => `${labels[k] || k} ${testing[k].toLocaleString()}`).join(' · ')}
          </p>
        }
      </div>
    )
  }

  searchTermHandle = (e) => {
    this.setState({searchTerm:e.target.value});
    this.throttleInput(e.target.value);
  }
  throttleInput = (val) => {
    let newList = this.state.agentList.filter(data => {
      const term = val.toLowerCase()
      // Support recalls tenants by customer name / email / phone — match the
      // live contact fields AND the frozen onboarding snapshot, plus org
      // name/id, so search keeps working whichever source populated the row.
      const snap = data.onboarding || {};
      return data.email?.toLowerCase().includes(term)
        || data.info?.toLowerCase().includes(term)
        || data.mobile?.toLowerCase().includes(term)
        || data.name?.toLowerCase().includes(term)
        || data.userId?.toLowerCase().includes(term)
        || data.defaultHeader?.toLowerCase().includes(term)
        || data.id?.toLowerCase?.().includes(term)
        || data.contactName?.toLowerCase().includes(term)
        || data.contactEmail?.toLowerCase().includes(term)
        || snap.contactName?.toLowerCase().includes(term)
        || snap.contactEmail?.toLowerCase().includes(term)
        || snap.contactPhone?.toLowerCase().includes(term)
    });
    this.setState({filteredAgentList: newList});
  }
  clearSearch = (e) => {
    e.stopPropagation()
    this.searchTermHandle({target: {value: ''}})
  }
  render() {
    const isMobile = window.isMobile();
    const {
      showWait,showFullDetails, blockNumber, showBlockNumber, blockedList, searchTerm, filteredAgentList, showOnboarding, showOnboardingList, showSeedConfig, activeTab
    } = this.state;
    return (
      <div className='sms-parent-container' style={isMobile ? {padding: 8} : {}}>
        <div className='sms-small-container'>
          {
            showSeedConfig ?
              <SeedConfig onClose={() => this.setState({ showSeedConfig: false })} />
              : showOnboarding ?
                <OnboardOrg hideSumbitRequest={(refresh) => {
                  if (refresh) { this.agentReq = true; this.props.getAllAgent(); }
                  this.setState({ showOnboarding: false });
                }} />
                : showOnboardingList ?
                  <OnboardingList onClose={() => this.setState({ showOnboardingList: false })} />
                  :
                  <div>
                    <Box sx={{borderBottom: 1, borderColor: 'divider', mb: 2}}>
                      {/* Search is open to the whole admin-panel tier, support
                          included. It used to be platform-admin only, citing
                          `admin:search:read: [admin, platform_admin]` — an action
                          that does not exist in permissions.yaml at all. Every
                          finder actually resolves to one of two actions, and
                          platform_support holds BOTH:

                            /api/v3/organizations        admin:organizations:list
                            /api/v1/admin/search/identity admin:organizations:list
                            /api/v1/admin/search/api_key  admin:search:api_key

                          So the tab was hidden from the people it was built for —
                          answering "which customer does this header / DLT id /
                          API key belong to?" is daily support work, not admin work.
                          Explicit values keep activeTab stable when it's hidden. */}
                      <Tabs value={activeTab} onChange={(e, v) => this.setState({activeTab: v})}>
                        <Tab label="Customers" value={0} />
                        {isAdminPanelRole(getFromLocalStorage().role) && <Tab label="Search" value={1} />}
                        <Tab label="Account Status" value={2} />
                      </Tabs>
                    </Box>
                    {activeTab !== 0 ?
                      /* Search tab stays mounted while the details Dialog overlays
                        it, so closing the dialog drops back to the search result. */
                      (activeTab === 1 ?
                        <SearchTab orgs={this.state.agentList} onOpenOrg={this.openDetails} /> :
                        <AccountStatusTab onOpenOrg={this.openDetails} />)
                      :
                      <div>
                        <div>
                          <div>
                            <p style={{fontSize: 14}}>Total SMS Balance of Customers (excluding testing accounts)</p>
                            {this.getTotalSMSCount()}
                          </div>
                          <div style={{marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap'}}>
                            {isAdminToolRole(getFromLocalStorage().role) && <div style={{display: 'flex', alignItems: 'center', gap: 8}}>
                              <TextField
                                className={"edit"}
                                value={blockNumber}
                                onChange={(e)=>{this.setState({blockNumber : e.target.value})}}
                                size="small"
                                variant="standard"
                                required
                                label="Enter Block Number" />
                              <Button onClick={this.addBlockNumber} variant='outlined'>
                                Add Block Number
                              </Button>
                            </div>}
                            <div style={{display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap'}}>
                              <Button onClick={() => this.setState({showOnboarding: true})} variant='contained' color='primary'>
                                Onboard New Org
                              </Button>
                              <Button onClick={() => this.setState({showOnboardingList: true})} variant='outlined'>
                                Onboarding History
                              </Button>
                              {isAdminToolRole(getFromLocalStorage().role) && <>
                                <Button onClick={() => this.setState({showSeedConfig: true})} variant='outlined' color='secondary'>
                                  Default Config
                                </Button>
                                <Button onClick={this.shoBlockedList} variant='outlined'>
                                  Show Block Number
                                </Button>
                              </>}
                            </div>
                          </div>
                        </div>
                        <div style={{display: 'flex', alignItems: 'center', gap: 16, padding: '16px 0'}}>
                          <TextField
                            className={"edit"}
                            value={searchTerm}
                            onChange={this.searchTermHandle}
                            size="small"
                            variant="standard"
                            label="Search Customer" />
                          {searchTerm && 
                            <Tooltip title="Clear Search">
                              <IconButton onClick={this.clearSearch}>
                                <HighlightOff />
                              </IconButton>
                            </Tooltip>
                          }
                        </div>
                        <Table
                          column={customerColumns(this.openDetails)}
                          serialNumber
                          data={filteredAgentList}
                          showPagination
                          pageOptions={[100, 200, 500]}
                          defaultPageSize={500}
                        />
                      </div>
                    }
                  </div>
          }
        </div>
       
        {
          showFullDetails ?
            <CustomerDetails
              data={this.detailsData}
              closeDetails={this.closeDetails}
              closeDetailsAndRefresh={this.closeDetailsAndRefresh}
              changeStatus={this.changeStatus}
              editDLT={this.editDLT}
              addSenderId={this.addSenderId}
              changeDefaultSenderId={this.changeDefaultSenderId}
              addBalance={this.addBalance}
              changePassword={this.changePassword}
              addSMSType={this.addSMSType}
              getTenantUsers={this.props.getTenantUsers}
              onOrgRenamed={this.handleOrgRenamed}
              impersonateUser={this.handleImpersonateUser} />
            : null
        }
        {
          showBlockNumber &&
          <Dialog open={true} onClose={this.closeBlockedList}>
            <DialogTitle>Blocked Number List</DialogTitle>
            <DialogContent dividers>
              <div>
                {blockedList.map(data=>(<div style={{fontSize: 16}} key={data._id}>{data.mobileNumber}</div>))}
              </div>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.closeBlockedList}>Close</Button>
            </DialogActions>
          </Dialog>
        }
        {
          showWait ?
            <Dialog open={true}>
              <DialogContent>
                <CircularProgress />
              </DialogContent>

            </Dialog>
            : null
        }
      </div>
    )
  }
}
function mapStateToProps(state){
  return {
    agentList : state.adminPanel.agentResponse,
    addBalanceRes : state.adminPanel.addBalanceResponse,
    changeStatusReq : state.adminPanel.changeStatusResponse,
    editDLTReq: state.adminPanel.editDLTResponse,
    addSenderIdReq : state.adminPanel.addSenderIdResponse,
    changeDefaultSenderIdReq : state.adminPanel.changeDefaultSenderIdResponse,
    addSMSTypeRes : state.adminPanel.addSMSTypeResponse,
    addBlockNoRes: state.adminPanel.addBlockNoResponse,
    blockNumberRes: state.adminPanel.blockNumberResponse,
    changePasswordRes: state.adminPanel.changePasswordResponse,
    tenantDetailsRes: state.adminPanel.tenantDetailsResponse,
    impersonateUserRes: state.adminPanel.impersonateUserResponse
  }
}
export default connect(mapStateToProps,{
  getAllAgent,addBalance,changeStatus,editDLT,addSenderId,changeDefaultSenderId,addSMSType,addBlockNo,getBlockNumber,getTenantDetails,getTenantUsers,changePassword,impersonateUser
})(AdminPanel)
